import { useState } from 'react'

import GenericTabs from '../../../components/tabs/tabs'

import AnalysisSet from './analysis-set'

const Header = ( {selectedGridRow} ) => {
 
  return (
      <div className='header'>
          <span> { selectedGridRow.nctNumber } </span>
          <span> { selectedGridRow.title } </span>
      </div>
  )
}

const RightContent = ( { selectedGridRow={} } ) => {
  const [tabs, setTabs] = useState([
    { id: "tab1", title: "General", content:<span>General</span> },
    { id: "tab2", title: "Analysis Set", content:<AnalysisSet/> },
    { id: "tab3", title: "Demographics and Baseline", content: <div>Settings Content</div>, },
    { id: "tab4", title: "Medical History", content: <div>Settings Content</div>, },
    { id: "tab5", title: "Concomitant Medication", content: <div>Settings Content</div>, },
    { id: "tab6", title: "Endpoint", content: <div>Settings Content</div>, },
    { id: "tab7", title: "Statistical Methods", content: <div>Settings Content</div>, },
    { id: "tab8", title: "Adverse Events", content: <div>Settings Content</div>, },
  ]);

  const handleTabChange = (tab, idx) => {
    console.log("Selected tab:", tab, "Index:", idx);
  };
  return (
    <>
       <Header selectedGridRow={selectedGridRow}/>
       <div style={{marginTop:"5px"}}>
          <GenericTabs
           tabs={tabs}
           onTabChange={handleTabChange}
           closable={false}
           style = { { height:"calc( 100vh - 50px )" }}
           initialSelIndex = { 1 }
        />
       </div>
    </>
  )
}

export default RightContent